// extracted by mini-css-extract-plugin
export default {"item":"styles_item__t6-HY","cartShop":"styles_cartShop__O+XAb"};